// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3930) return "static/chunks/164f4fb6-a5e9e9848d1de55e.js";
	if (chunkId === 5033) return "static/chunks/2f0b94e8-f9e55d9e16f182f7.js";
	if (chunkId === 6241) return "static/chunks/6241-fc88e10f88f0883d.js";
	if (chunkId === 6941) return "static/chunks/6941-14667cff97ab6c6f.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","1761":"d0deef33","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"7e63d871e474c3ee","1018":"3a1385fa0c82e9c4","1761":"1fe3afdf5d5ad41b","2641":"bcaf43e58fc32788","2931":"e3cb05d870a0a15b","4316":"890f6f4190c9fdfb","6580":"d4c04ab453e24d97","6904":"00630a44df6bfd26"}[chunkId] + ".js";
};